<app-main-header [name_main]="'Libreria de objetos'">
  <button class="check-btn" mat-icon-button (click)="openFilePicker()" [disabled]="true">
    <span class="material-symbols-outlined"> database_upload </span>
  </button>

  <div *ngIf="uploadMessage" class="file-info" [class.error]="isError">
    <p>{{ uploadMessage }}</p>
  </div>

  <button class="check-btn" mat-flat-button routerLink="/library-objects/create">
    NUEVO
  </button>

  <input type="file" #fileInput (change)="onFileSelectedAndUpload($event)" accept=".csv" style="display: none" />

</app-main-header>



<ng-template #empty>
  <div class="empty-message">No hay productos disponibles.</div>
</ng-template>

<div class="page-container">



  <div class="content-area">

    <div class="filters-section">

      <div class="search-wrapper">
        <mat-form-field class="custom-search-bar" appearance="fill">
          <div matPrefix>
            <button mat-button [matMenuTriggerFor]="filtersMenu" class="menu-trigger-button">
              <span>Filtros</span>
              @if(selectedFiltersCount > 0){
              <span class="filter-badge">{{ selectedFiltersCount }}</span>
              }
              <mat-icon>filter_list</mat-icon>
            </button>
          </div>

          <input matInput #searchInput placeholder=" Busca aquí..." [(ngModel)]="searchValue"
            (keydown.enter)="onSearch()" (input)="onSemanticSearch($event)" />

          @if (searchValue) {
          <button mat-icon-button matSuffix (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
          }
          <mat-icon matSuffix (click)="onSearch()" style="cursor: pointer;">search</mat-icon>

        </mat-form-field>

        <div class="semantic-results" *ngIf="showSemanticResults" (click)="$event.stopPropagation()">

          <mat-progress-spinner *ngIf="isSemanticLoading" diameter="30">
          </mat-progress-spinner>

          <div class="semantic-item" *ngFor="let item of semanticResults" (click)="onSemanticSelect(item)">
            <div class="semantic-thumbnail">
              @if(item?.thumbnail === '' || item?.thumbnail === 'NULL' || item?.thumbnail === null ||
              item?.thumbnail === undefined ){
              <img class="no-image-semantic" src="assets/icons/no_image.svg" alt="">
              } @else {
              <!-- <mat-icon class="product-card-placeholder">image</mat-icon> -->

              <img [src]="item.thumbnail" alt="image">
              }
            </div>
            <div class="semantic-info">
              <div class="semantic-header">
                <span class="semantic-id">ID {{ item.id }}</span>
              </div>

              <div class="semantic-name">{{ item.name }}</div>

              <!-- <div class="semantic-attrs">
                <mat-chip-listbox class="semantic-chip-list">
                  <mat-chip class="semantic-chip" *ngFor="let group of item.groupedAttributes">
                    <span class="chip-label">{{ group.typeLabel }}:</span>
                    <span class="chip-value">
                      {{ group.values.join(', ') }}
                    </span>
                  </mat-chip>
                </mat-chip-listbox>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <mat-menu #filtersMenu="matMenu" panelClass="filters-menu-panel" backdropClass="custom-filter-backdrop">

        <div class="menu-content two-columns" (click)="$event.stopPropagation()">
          <div class="filter-column">
            <div class="title-menu-filter">
              <mat-icon>radio_button_checked</mat-icon>
              <span><b>Filtrar por estado</b></span>
            </div>

            <div class="menu-item-checkbox">

              <mat-checkbox class="check" color="primary" [(ngModel)]="activeFilter.selected"
                (ngModelChange)="onFilterChange(activeFilter)">
              </mat-checkbox>


              <mat-form-field appearance="outline" class="sub-filter-select full-width">
                <mat-label>Estado</mat-label>
                <mat-select [(ngModel)]="activeFilter.subFilterValue"  [disabled]="!activeFilter.selected" (selectionChange)="onSubFilterSelect()">

                  <mat-option *ngFor="let active of activeFilter.subFilterOptions" [value]="active.id">
                    {{ active.name }}
                  </mat-option>

                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-column">
            <div class="title-menu-filter">
              <mat-icon>business</mat-icon>
              <span><b>Filtrar por cliente</b></span>
            </div>

            <div class="menu-item-checkbox">

              <mat-checkbox class="check" color="primary" [(ngModel)]="clientFilter.selected"
                (ngModelChange)="onFilterChange(clientFilter)">
              </mat-checkbox>


              <mat-form-field appearance="outline" class="sub-filter-select full-width">
                <mat-label>Cliente</mat-label>
                <mat-select [(ngModel)]="clientFilter.subFilterValue"  [disabled]="!clientFilter.selected" (selectionChange)="onSubFilterSelect()">

                  <mat-option *ngFor="let client of clientFilter.subFilterOptions" [value]="client.id">
                    {{ client.name }}
                  </mat-option>

                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-column">
            <div class="title-menu-filter">
              <mat-icon>filter_list</mat-icon>
              <span><b>Filtrar por atributos</b></span>
            </div>

            <ng-container *ngFor="let filter of attributeFilters">
              <div class="menu-item-checkbox">
                <mat-checkbox class="check" color="primary" [(ngModel)]="filter.selected"
                  (ngModelChange)="onFilterChange(filter)">
                </mat-checkbox>

                <mat-form-field appearance="outline" class="sub-filter-select">
                  <mat-label>{{ filter.displayName }}</mat-label>
                  <mat-select [(ngModel)]="filter.subFilterValue" [disabled]="!filter.selected"
                    (selectionChange)="onSubFilterSelect()">

                    <mat-option *ngFor="let option of filter.subFilterOptions" [value]="option.id">
                      {{ option.name }}
                    </mat-option>

                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>
          </div>


        

        </div>
      </mat-menu>


    </div>

    <ng-container *ngIf="apiResponse$ | async as response; else loading">

      <div class="cards-container" *ngIf="response.data.length > 0; else noData">
        <mat-card *ngFor="let product of response.data" class="product-card" (click)="sendObjects(product)"
          role="button" tabindex="0" (keydown.enter)="sendObjects(product)">
          <mat-card-header class="card-h">
            @if(product?.thumbnail === '' || product?.thumbnail === 'NULL' || product?.thumbnail === null ||
            product?.thumbnail === undefined ){
            <img class="no-image" src="assets/icons/no_image.svg" alt="">
            } @else {
            <!-- <mat-icon class="product-card-placeholder">image</mat-icon> -->

            <img class="product-card-image" [src]="product.thumbnail" alt="image">
            }
          </mat-card-header>
          <mat-card-content>


            @if(product.client_library_objects){
            <span *ngFor="let d of product.client_library_objects"> {{d.client_id === 6 ? 'Alpina' : '' }} </span>
            }

            <mat-card-title class="product-card-title">{{ product.name }}</mat-card-title>
            <div class="cotn-ois">
              <span class="loi">LOI: {{product.library_object_id}}</span>
              <span class="cloi">COI: {{product.library_object_id}}</span>
            </div>
            <div class="">

            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="content-paginator">
        <mat-paginator (page)="handlePageEvent($event)" [length]="totalItems" [pageSize]="requestParams.limit"
          [pageIndex]="requestParams.page! - 1" [pageSizeOptions]="[20, 50]" [disabled]="isLoading" showFirstLastButtons
          aria-label="Select page">
        </mat-paginator>
      </div>
      <ng-template #noData>
        <div class="info-message">

          <p>No se encontraron objetos para mostrar.</p>
        </div>
      </ng-template>

    </ng-container>

    <ng-template #loading>
      <div class="loading-spinner">
        <mat-spinner [diameter]="100" [strokeWidth]="3"></mat-spinner>
        <br>
        <p>Cargando objetos...</p>
      </div>
    </ng-template>
  </div>




</div>